@if (config) {
  <mat-card>
    <div class="cabecera">
      @if (config.datosPersonales?.urlFoto && !fotoError) {
        <img
          class="avatar-vecino"
          [src]="config.datosPersonales?.urlFoto"
          [alt]="config.datosPersonales?.nombre"
          (error)="fotoError = true"
        />
      } @else {
        <mat-icon class="avatar-vecino-fallback">account_circle</mat-icon>
      }
      <div
        class="nombre"
        [matTooltip]="config.datosPersonales?.nombre || ''"
      >
        @if (config.datosPersonales?.nombre) {
          {{ config.datosPersonales?.nombre }}
        } @else {
          <span class="no-info">Sin nombre</span>
        }
      </div>
    </div>
    <div class="sub-datos">
      @if (config.datosPersonales?.dni) {
        <span>DNI {{ config.datosPersonales?.dni }}</span>
      } @else {
        <span class="no-info">Sin DNI</span>
      }
      <span class="separador">·</span>
      @if (config.datosPersonales?.fechaNacimiento) {
        <span>{{
          config.datosPersonales?.fechaNacimiento | date: "shortDate"
        }}</span>
      } @else {
        <span class="no-info">Sin fecha de nac.</span>
      }
      @if (config.datosPersonales?.sexo === true) {
        <span class="separador">·</span>
        <mat-icon class="sexo-icon" matTooltip="Masculino">male</mat-icon>
      } @else if (config.datosPersonales?.sexo === false) {
        <span class="separador">·</span>
        <mat-icon class="sexo-icon" matTooltip="Femenino">female</mat-icon>
      }
    </div>

    <mat-card-content>
      <!-- Estado -->
      <div class="chips">
        <span
          class="chip"
          [class.on]="config.ultimoAcceso"
          [matTooltip]="
            config.ultimoAcceso
              ? 'Último acceso: ' + (config.ultimoAcceso | date: 'short')
              : 'Nunca ingresó a la app'
          "
        >
          <mat-icon>{{
            config.ultimoAcceso ? "check_circle" : "highlight_off"
          }}</mat-icon>
          {{ config.ultimoAcceso ? "App activa" : "App inactiva" }}
        </span>
        <span
          class="chip"
          [class.on]="config.tokenPush"
          matTooltip="Notificaciones push"
        >
          <mat-icon>{{
            config.tokenPush ? "notifications_active" : "notifications_off"
          }}</mat-icon>
          {{ config.tokenPush ? "Notificaciones" : "Sin notif." }}
        </span>
      </div>

      <!-- Contacto -->
      <div class="filas">
        <div class="fila" matTooltip="Email">
          <mat-icon>email</mat-icon>
          @if (config.datosPersonales?.email) {
            <span class="valor">{{ config.datosPersonales?.email }}</span>
          } @else {
            <span class="no-info">Sin email</span>
          }
        </div>
        <div class="fila" matTooltip="Teléfono">
          <mat-icon>phone</mat-icon>
          @if (config.datosPersonales?.telefono) {
            <span class="valor">{{ config.datosPersonales?.telefono }}</span>
          } @else {
            <span class="no-info">Sin teléfono</span>
          }
        </div>
        <div class="fila" matTooltip="Modo de registro">
          <mat-icon>how_to_reg</mat-icon>
          <span class="valor">{{ getModoRegistro(config) }}</span>
        </div>
        <div class="fila" matTooltip="Fecha de creación">
          <mat-icon>event</mat-icon>
          @if (config.fechaCreacion) {
            <span class="valor">
              Creado el {{ config.fechaCreacion | date: "short" }}
            </span>
          } @else {
            <span class="no-info">Sin fecha de creación</span>
          }
        </div>
      </div>

      <!-- Config por cliente -->
      <app-config-vecino [config]="config" />
    </mat-card-content>

    <mat-card-actions>
      <button
        class="accion peligro"
        matTooltip="Eliminar"
        (click)="eliminar(config)"
      >
        <mat-icon>delete</mat-icon>
      </button>
      <span class="grow"></span>
      <button
        class="accion"
        matTooltip="Desloguear"
        (click)="desloguear(config)"
      >
        <mat-icon>logout</mat-icon>
      </button>
      <button class="accion" matTooltip="Editar" (click)="editar(config)">
        <mat-icon>edit</mat-icon>
      </button>
    </mat-card-actions>
  </mat-card>
}
